import { useEffect } from "react";

const LAYER_ID = "eh-vacation-bubbles-layer";
const LIGHT_COUNT = 5;
const LIGHT_MOTION_VERSION = "2";

function buildLightsInner(): HTMLDivElement {
  const inner = document.createElement("div");
  inner.className = "eh-vacation-lights";
  inner.dataset.motion = LIGHT_MOTION_VERSION;
  for (let i = 0; i < LIGHT_COUNT; i += 1) {
    const light = document.createElement("span");
    light.className = "eh-vacation-light";
    light.style.left = `${8 + (i * 84) / LIGHT_COUNT + Math.random() * 6}%`;
    const size = 88 + Math.random() * 72;
    light.style.setProperty("--eh-vacation-size", `${size}px`);
    const drift = (12 + Math.random() * 28) * (Math.random() > 0.5 ? 1 : -1);
    light.style.setProperty("--eh-vacation-drift", `${drift}px`);
    light.style.animationDuration = `${38 + Math.random() * 24}s`;
    light.style.animationDelay = `${-Math.random() * 30}s`;
    inner.appendChild(light);
  }
  return inner;
}

/** Urlaubs-Hintergrund und sehr dezente Lichtakzente (keine Emojis). */
export function useVacationEffects(
  seasonActive: boolean,
  options: { showBubbles?: boolean; showSeasonDecor?: boolean } = {},
): void {
  const showLights = options.showBubbles ?? seasonActive;
  const showSeasonDecor = options.showSeasonDecor ?? seasonActive;

  useEffect(() => {
    if (typeof document === "undefined") return;

    const teardownLights = () => {
      const layer = document.getElementById(LAYER_ID);
      layer?.setAttribute("hidden", "");
    };

    const teardownAll = () => {
      document.body.classList.remove("eh-vacation-season");
      teardownLights();
    };

    if (!seasonActive) {
      teardownAll();
      return teardownAll;
    }

    document.body.classList.toggle("eh-vacation-season", showSeasonDecor);

    if (!showLights) {
      teardownLights();
      return () => {
        document.body.classList.remove("eh-vacation-season");
      };
    }

    let layer = document.getElementById(LAYER_ID);
    if (!layer) {
      layer = document.createElement("div");
      layer.id = LAYER_ID;
      layer.setAttribute("aria-hidden", "true");
      layer.appendChild(buildLightsInner());
      const anchor = document.body.firstElementChild;
      if (anchor) document.body.insertBefore(layer, anchor);
      else document.body.appendChild(layer);
    } else {
      const inner = layer.querySelector(".eh-vacation-lights") as HTMLElement | null;
      if (!inner || inner.dataset.motion !== LIGHT_MOTION_VERSION) {
        inner?.remove();
        layer.appendChild(buildLightsInner());
      }
    }

    layer.removeAttribute("hidden");

    return () => {
      document.body.classList.remove("eh-vacation-season");
      teardownLights();
    };
  }, [seasonActive, showLights, showSeasonDecor]);
}
